import type { ReactElement } from 'react';
import { QuoteShortcutTile } from './quote-shortcut-tile';
import { QUOTE_SHORTCUTS } from './quote-shortcuts';

/** 견적문의 바로가기 — 아직 디자인이 없다면 상품·기획전·제작 사례에서 시작한다. */
export const QuoteGuideShortcuts = (): ReactElement => (
  <section aria-labelledby="quote-shortcuts-heading" className="flex flex-col gap-8 sm:gap-10">
    <header className="flex flex-col gap-4">
      <h2
        id="quote-shortcuts-heading"
        className="text-[clamp(2rem,3.6vw,3.25rem)] leading-none font-bold tracking-[-0.03em]"
      >
        <span aria-hidden>Start here</span>
        <span className="sr-only">바로가기</span>
      </h2>
      <p className="text-[15px] text-muted-foreground sm:text-base">
        아직 디자인이 없다면 여기에서 시작해 보세요.
      </p>
    </header>

    <ul className="grid gap-x-6 sm:grid-cols-3">
      {QUOTE_SHORTCUTS.map((shortcut) => (
        <QuoteShortcutTile key={shortcut.to} shortcut={shortcut} />
      ))}
    </ul>
  </section>
);
